var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3"},[_c('h1',{staticClass:"subheading grey--text"},[_vm._v("Home")]),_c('v-container',{attrs:{"fluid":""}},[(_vm.pictures)?_c('Pictures'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }